var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Finder = function Finder(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '-13.7 17.9 16.2 16.7' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M2.5 34l-3.9-4.3C-.3 28.5.3 26.8.3 25.1c0-3.9-3.1-7.1-7-7.1s-7 3.2-7 7.1 3.1 7.1 7 7.1c1.8 0 3.3-.7 4.6-1.7l3.9 4.3.7-.8zm-15.2-9c0-3.4 2.7-6.1 6-6.1s6 2.7 6 6.1c0 3.4-2.7 6.1-6 6.1s-6-2.8-6-6.1z',
        className: 'st0' })
    )
  );
};
/*eslint-enable */

export default Finder;
//# sourceMappingURL=Finder.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Finder.js